module.exports = __webpack_public_path__ + "img/feedback.239e03bb.png";